import { ReactNode } from "react";
import { AppHeader } from "./AppHeader";
import { BottomNav } from "./BottomNav";
import { InstallPWABanner } from "./InstallPWABanner";

export const AppShell = ({ children, title }: { children: ReactNode; title?: string }) => (
  <div className="min-h-screen bg-muted/30 pb-20 md:pb-0">
    <AppHeader title={title} />
    <main className="container max-w-5xl px-4 py-6">{children}</main>
    <BottomNav />
    <InstallPWABanner />
  </div>
);
